import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import MultiSelectActivityTypeField from "@app/component/input/MultiSelectActivityTypeField";
import RadioGroup from "@app/component/input/RadioGroup";
import SwitchLine from "@app/scene/dashboard/components/cards/common/DefaultPreferencesFormComponent/components/SwitchLine";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";
import { CustomerFaceTimeAggregationType } from "@app/types/dashboard/cards/customerFaceTime/CustomerFaceTimeCardConfiguration";

const messages = defineMessages({
  activityTypes: {
    id: "dashboard.editModal.criteria.customerFaceTime.activityTypes",
    defaultMessage: "Activity Type(s)",
    description:
      "Title of the Activity Types field in a criteria form in Edit Customer Face Time Modal on Dashboard",
  },
  activityTypesPlaceholder: {
    id: "dashboard.editModal.criteria.customerFaceTime.activityTypes.placeholder",
    defaultMessage: "All Types",
    description:
      "Placeholder of the Activity Types field in a criteria form in Edit Customer Face Time Modal on Dashboard",
  },
  aggregationType: {
    id: "dashboard.editModal.criteria.customerFaceTime.aggregationType",
    defaultMessage: "Aggregation type",
    description:
      "Title of the Aggregation type field in a criteria form in Edit Customer Face Time Modal on Dashboard",
  },
  includeUnverifiedCheckIns: {
    id: "dashboard.editModal.criteria.customerFaceTime.includeUnverifiedCheckIns",
    defaultMessage: "Include data from unverified Check-Ins",
    description:
      "Label of the Include Unverified Customer Face Time switch in a criteria form in Edit Customer Face Time Modal on Dashboard",
  },
});

const CriteriaFormComponent: React.FC<CardConfigurationProps> = ({ disabled }) => {
  const intl = useIntl();

  return (
    <div>
      <Form.Item
        label={intl.formatMessage(messages.aggregationType)}
        name={["criteria", "aggregationType"]}
      >
        <RadioGroup
          defaultValue={CustomerFaceTimeAggregationType.SUM}
          options={[CustomerFaceTimeAggregationType.SUM, CustomerFaceTimeAggregationType.AVG]}
          optionType="button"
        />
      </Form.Item>
      <Form.Item
        label={intl.formatMessage(messages.activityTypes)}
        name={["criteria", "activityTypeIds"]}
      >
        <MultiSelectActivityTypeField
          allowClear
          disabled={disabled}
          placeholder={intl.formatMessage(messages.activityTypesPlaceholder)}
          showArrow
          suffixIcon={disabled ? <FontAwesomeIcon icon={faLock} /> : undefined}
        />
      </Form.Item>
      <Form.Item name={["criteria", "includeUnverified"]} noStyle>
        <SwitchLine
          disabled={disabled}
          label={intl.formatMessage(messages.includeUnverifiedCheckIns)}
        />
      </Form.Item>
    </div>
  );
};

export default CriteriaFormComponent;
